import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '../../../../../shared/components/Button';
import { ACTIONS } from '../../../../../utils/constants';
import { showAlertOffer } from '../../userOffer/DraftsSection';
import classes from './ObjectAttributesBox.module.scss';
import ObjectAttributesSidePane from './ObjectAttributesSidePane';
import { INFLUENCERS_ENDPOINTS } from '../../../../../config/api';
import { useHistory, useLocation } from 'react-router';

/**
 *
 * @typedef ObjectAttributeBoxProps
 * @param {import('../../../../../reducers/offer.reducer').Offer} offer
 *
 * @param {ObjectAttributeBoxProps} props
 * @returns
 */
const ObjectAttributesBox = ({ offer }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    sidePane: {
      open: false,
      render: false
    },
    openSidePaneOnEnter: false,
    generalObjectAttributes: offer.object_attribute_metadata.filter(oa => oa.influencer_ui_view === 'general')
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryShowParticipantQuestions = queryParams.has('participant_fields');

    if (queryShowParticipantQuestions) {
      setState({
        ...state,
        openSidePaneOnEnter: true
      });
    }
  }, [location, history]);

  const toggleSidePane = ({
    open = false,
    render = false,
    success = undefined,
    action = ACTIONS.CREATE,
  }) => {
    document.body.style.overflow = open ? 'hidden' : 'unset';
    setState({
      ...state,
      sidePane: {
        open,
        render
      },
      openSidePaneOnEnter: false
    });
    showAlertOffer({ success, action, dispatch });
  };

  const viewableFields = useMemo(() => state.generalObjectAttributes.filter(oa => !oa.is_editable_by_influencer), [state.generalObjectAttributes]);
  const hasEditableFields = viewableFields.length < state.generalObjectAttributes.length;

  return <div className={classes.ObjectAttributesBox}>
    <div className="flex-column">
      <div className={classNames('align-items-center', classes.wrapper)}>
        <div className='mr-3'>
          <i className='fal fa-2x fa-clipboard-list tc-blue' />
        </div>
        {hasEditableFields &&
          <div className='d-flex flex-column flex-sm-row flex-fill align-items-sm-center'>
            <div className='flex-fill'>
              {t('influencers.pages.campaign.oas.description')}
            </div>
            <div className='justify-content-end d-flex'>
              <Button variant="tertiary" onClick={() => toggleSidePane({ open: true, render: true })}>
                {t('influencers.pages.campaign.oas.cta')}
                <i className='fal fa-arrow-circle-right icon-right' />
              </Button>
            </div>
          </div>
        }
      </div>
      {hasEditableFields && viewableFields.length > 0 && <hr />}
      {
        viewableFields.length > 0 ?
          <div className={classNames('flex-column', classes.wrapper)}>
            {
              viewableFields.map((oa) =>
                <div key={oa.id} dangerouslySetInnerHTML={{ __html: oa.label }} />
              )
            }
          </div> : null
      }
    </div>
    {(state.sidePane.render || state.openSidePaneOnEnter)
      ? <ObjectAttributesSidePane
        open={state.sidePane.open || state.openSidePaneOnEnter}
        onRequestClose={() => toggleSidePane({
          render: true
        })}
        onAfterClose={(success, action = ACTIONS.UPDATE) =>
          toggleSidePane({
            open: false,
            render: false,
            success,
            action,
          })
        }
        objectAttributeMetadata={state.generalObjectAttributes}
        objectAttributeValues={offer.user_offer.object_attribute_values}
        objectAttributeEndpoint={INFLUENCERS_ENDPOINTS.USER_OFFERS(offer.user_offer.id)}
        updateType='general'
      /> : null}
  </div>;
};

ObjectAttributesBox.propTypes = {
  offer: PropTypes.object.isRequired
};

export default ObjectAttributesBox;